if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="discount"]');
        this.button = this.querySelector('.cart-discount__apply');
        this.message = this.querySelector('.cart-discount__message');
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          const code = this.input.value.trim();
          if (code) this.apply(code);
        });
        this.input.addEventListener('input', () => {
          const start = this.input.selectionStart;
          this.input.value = this.input.value.toUpperCase();
          this.input.setSelectionRange(start, start);
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('.cart-discount__remove');
          if (btn) this.remove(btn.dataset.code);
        });
        this.sync();
      }

      // This theme's Liquid does not expose cart.discount_codes, so read them from the cart JSON.
      async sync() {
        try {
          const cart = await fetch(`${routes.cart_url}.js`).then((r) => r.json());
          this.render(cart.discount_codes || []);
        } catch (e) {
          /* leave the field usable even if the sync fails */
        }
      }

      render(codes) {
        const applied = codes.filter((d) => d.applicable).map((d) => d.code);
        this.dataset.codes = applied.join(',');
        const list = this.querySelector('.cart-discount__codes');
        if (!list) return;
        list.innerHTML = applied
          .map(
            (code) =>
              `<li class="cart-discount__code"><span></span><button type="button" class="cart-discount__remove" data-code="${code.replace(/"/g, '&quot;')}" aria-label="Remove discount code">&times;</button></li>`
          )
          .join('');
        list.querySelectorAll('.cart-discount__code span').forEach((span, i) => {
          span.textContent = applied[i];
        });
      }

      currentCodes() {
        return (this.dataset.codes || '').split(',').map((c) => c.trim()).filter(Boolean);
      }

      async apply(code) {
        const existing = this.currentCodes().filter((c) => c.toUpperCase() !== code.toUpperCase());
        const cart = await this.update([...existing, code]);
        if (!cart) return;
        const match = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
        if (match && match.applicable) {
          this.setMessage('');
          this.input.value = '';
          this.render(cart.discount_codes || []);
          await this.refresh('', cart.discount_codes || []);
        } else {
          // Drop the code that didn't work so it doesn't stick to the cart
          await this.update(existing);
          this.setMessage((window.cartDiscountStrings?.invalid || "Discount code isn’t valid for the items in your cart."), true);
        }
      }

      async remove(code) {
        const remaining = this.currentCodes().filter((c) => c.toUpperCase() !== code.toUpperCase());
        const cart = await this.update(remaining);
        if (cart) {
          this.render(cart.discount_codes || []);
          await this.refresh('', cart.discount_codes || []);
        }
      }

      async update(codes) {
        this.button.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({ discount: codes.join(',') }),
          });
          const cart = await res.json();
          if (cart.errors || cart.status) throw new Error(cart.description || cart.errors);
          return cart;
        } catch (e) {
          this.setMessage(window.cartStrings?.error || (window.cartDiscountStrings?.error || 'There was an error while updating your cart. Please try again.'), true);
          return null;
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }

      async refresh(announcement, codes) {
        const inDrawer = !!this.closest('cart-drawer');
        const footerId = document.getElementById('main-cart-footer')?.dataset.id;
        const itemsId = document.getElementById('main-cart-items')?.dataset.id;
        const sections = inDrawer ? ['cart-drawer'] : [footerId, itemsId].filter(Boolean);
        try {
          const res = await fetch(`${window.location.pathname}?sections=${sections.join(',')}`);
          const data = await res.json();
          const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
          const swap = (targetSel, doc, sourceSel) => {
            const target = document.querySelector(targetSel);
            const source = doc.querySelector(sourceSel);
            if (target && source) target.innerHTML = source.innerHTML;
          };
          if (inDrawer) {
            const doc = parse(data['cart-drawer']);
            swap('#CartDrawer-CartItems', doc, '#CartDrawer-CartItems');
            swap('cart-drawer .cart-drawer__footer', doc, '.cart-drawer__footer');
          } else {
            swap('#main-cart-footer .js-contents', parse(data[footerId]), '.js-contents');
            if (itemsId) swap('#main-cart-items .js-contents', parse(data[itemsId]), '.js-contents');
          }
          const scope = inDrawer ? 'cart-drawer' : '#main-cart-footer';
          const fresh = document.querySelector(`${scope} cart-discount`);
          if (fresh) {
            if (codes) fresh.render(codes);
            if (announcement !== undefined) fresh.setMessage(announcement || '');
          }
        } catch (e) {
          window.location.reload();
        }
      }

      setMessage(text, isError = false) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.classList.toggle('cart-discount__message--error', isError);
      }
    }
  );
}
